import type { JSX } from 'react';

const SIZES = {
  sm: 'h-9 w-9 rounded-xl text-base',
  md: 'h-11 w-11 rounded-2xl text-lg',
  lg: 'h-14 w-14 rounded-2xl text-2xl',
} as const;

export function BrandMark({
  size = 'md',
  withWordmark = false,
}: {
  size?: keyof typeof SIZES;
  withWordmark?: boolean;
}): JSX.Element {
  const badge = (
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center bg-slate-900 font-bold text-amber-300 shadow-md dark:bg-slate-100 dark:text-amber-600 ${SIZES[size]}`}
    >
      J
    </span>
  );
  if (!withWordmark) return badge;
  return (
    <span className="inline-flex items-center gap-2.5">
      {badge}
      <span className="text-base font-semibold tracking-tight">J Calculator</span>
    </span>
  );
}
